import { computed } from 'vue';
import { useCheckoutStateStore } from '../components/checkout/stores/checkoutStateStore';
import { useShoppingCartStore } from '../components/shoppingCart/stores/shoppingCartStore';
import { CheckoutSteps } from '../services/models/checkout.models';
import { formatCurrency } from '../utils/currencyHelpers';
import { formatWithoutRounding } from '../utils/productPrice';

export function useCartSummary() {
  const shoppingCartStore = useShoppingCartStore();
  const checkoutStateStore = useCheckoutStateStore();

  const isShippingStep = computed(
    () =>
      checkoutStateStore.currentCheckoutStep === CheckoutSteps.Delivery ||
      checkoutStateStore.currentCheckoutStep === CheckoutSteps.Payment
  );

  const shippingCostFormatted = computed((): string => {
    const cart = shoppingCartStore.cart;
    if (!cart) return 'Beregnes senere';
    if (
      (cart.freeShippingActive && cart.freeShippingLimit.amount <= cart.subTotal.amount) ||
      !cart.selectedShippingMethodPrice.amount
    )
      return 'Fri frakt';
    if (cart.selectedShippingMethodPrice.amount && isShippingStep.value) {
      return `${formatCurrency(cart.selectedShippingMethodPrice.currency)} ${formatWithoutRounding(cart.selectedShippingMethodPrice.amount)}`;
    }
    return 'Beregnes senere';
  });

  const totalAmount = computed((): number => {
    if (isShippingStep.value) {
      return shoppingCartStore.cart?.total.amount || 0;
    }
    return shoppingCartStore.cart?.subTotal.amount || 0;
  });

  return { shippingCostFormatted, totalAmount };
}
